import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { ActivityRepository } from '@/store/activity-state/activity-state.repository';

interface IActivityFormObjectProps {
  store: ActivityRepository;
  activityCategoriesOptions: { label: string; value: number }[];
}

export const getActivityFormObject = ({ store, activityCategoriesOptions }: IActivityFormObjectProps): DynamicForm => {
  const libelleField: DynamicField<TextFieldProps> = {
    label: 'settings.activity.form.libelle.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'libelle'),
    props: {
      value: store.getNestedObservable<string>('dto', 'libelle'),
      onChange: (value: string) => {
        store.setNestedWithComparison('dto', 'libelle', value);
        store.setNested('errors', 'libelle', '');
      },
    },
  };

  const activityTypeField: DynamicField<SelectFieldProps> = {
    label: 'settings.activity.form.typeActivity.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'categorieActiviteId'),
    props: {
      placeholder: 'settings.activity.form.typeActivity.placeholder',
      options: activityCategoriesOptions?.map(cat => {
        return { name: cat.label, code: cat.value };
      }),
      value: store.getObservable('activityCategorySelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNestedWithComparison('dto', 'categorieActiviteId', value.code);
        store.setWithComparison('activityCategorySelected', value);
        store.setNested('errors', 'categorieActiviteId', '');
      },
    },
  };

  return {
    title: 'settings.activity.form.title',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [libelleField],
          },
          {
            fields: [activityTypeField],
          },
        ],
      },
    ],
  };
};
